/* Swaps the TrustBox template between breakpoints; the widget is a cross-origin iframe so it must be re-initialised, not restyled. */
(function () {
  'use strict';

  const MOBILE_QUERY = '(max-width: 767.98px)';
  const mobileQuery = window.matchMedia(MOBILE_QUERY);
  let queryListenerBound = false;

  function trustpilotReady() {
    return Boolean(window.Trustpilot && typeof window.Trustpilot.loadFromElement === 'function');
  }

  function applyVariant(widget, isMobile) {
    const wanted = isMobile ? 'mobile' : 'desktop';
    if (widget.dataset.activeVariant === wanted) return;

    const templateId = isMobile ? widget.dataset.mobileTemplateId : widget.dataset.desktopTemplateId;
    const token = isMobile ? widget.dataset.mobileToken : widget.dataset.desktopToken;
    const height = isMobile ? widget.dataset.mobileHeight : widget.dataset.desktopHeight;
    if (!templateId || !token || !height) return;

    // Setting the attributes is always safe: if Trustpilot has not scanned the DOM yet it renders the right variant unaided.
    widget.setAttribute('data-template-id', templateId);
    widget.setAttribute('data-token', token);
    widget.setAttribute('data-style-height', height);
    widget.dataset.activeVariant = wanted;

    // Only an already-rendered widget needs tearing down, and only when Trustpilot is present to rebuild it.
    const existing = widget.querySelector('iframe');
    if (!existing || !trustpilotReady()) return;
    existing.remove();
    window.Trustpilot.loadFromElement(widget, true);
  }

  // Re-queries every call so a section re-rendered in the theme editor is picked up rather than a stale node list.
  function syncAll() {
    const widgets = document.querySelectorAll('[data-trustpilot-responsive]');
    widgets.forEach(function (widget) {
      applyVariant(widget, mobileQuery.matches);
    });
  }

  function bindBreakpointListener() {
    if (queryListenerBound) return;
    queryListenerBound = true;
    // addEventListener on MediaQueryList is unsupported in older Safari, which still needs addListener.
    if (typeof mobileQuery.addEventListener === 'function') {
      mobileQuery.addEventListener('change', syncAll);
    } else if (typeof mobileQuery.addListener === 'function') {
      mobileQuery.addListener(syncAll);
    }
  }

  function init() {
    if (!document.querySelector('[data-trustpilot-responsive]')) return;
    bindBreakpointListener();
    syncAll();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
